"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgInfoCircle = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var SvgInfoCircle = function SvgInfoCircle(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "title", "desc", "titleId", "descId"]);
  return _react["default"].createElement(_Svg["default"], (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: "currentcolor"
  }, props), !!title && _react["default"].createElement("title", {
    id: titleId
  }, title), !!desc && _react["default"].createElement("desc", {
    id: descId
  }, desc), _react["default"].createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm2.658 18.284c-.661.26-2.952 1.354-4.272.191a1.676 1.676 0 01-.59-1.318c0-.998.328-1.868.919-3.957.104-.395.231-.907.231-1.313 0-.701-.266-.887-.987-.887-.352 0-.742.125-1.095.257l.195-.799c.787-.32 1.775-.71 2.621-.71 1.269 0 2.203.633 2.203 1.837 0 .347-.06.955-.186 1.375l-.73 2.582c-.151.522-.424 1.673-.001 2.014.416.337 1.401.158 1.887-.071l-.195.799zM13.452 8a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0113.452 8z"
  }));
};

exports.SvgInfoCircle = SvgInfoCircle;
SvgInfoCircle.isIcon = true;
SvgInfoCircle.defaultProps = {
  size: 24,
  'aria-hidden': 'true',
  focusable: 'false'
};
var _default = SvgInfoCircle;
exports["default"] = _default;